exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "p[data-v-a5134b24]{text-align:center;margin:0;color:#ff6449}.order-info[data-v-a5134b24]{margin:5px;transition:all .5s ease-out;-webkit-transition:all .5s ease-out;height:70px}.order-label[data-v-a5134b24]{letter-spacing:1px;font-weight:700;font-size:18px}.order-number[data-v-a5134b24]{font-size:40px;font-weight:700}.ready[data-v-a5134b24]{color:#70be00}@media screen and (max-width:320px){.order-label[data-v-a5134b24]{font-size:16px}.order-number[data-v-a5134b24]{font-size:25px;font-weight:700}}.fade-enter-active[data-v-a5134b24],.fade-leave-active[data-v-a5134b24]{transition:opacity .5s}.fade-enter[data-v-a5134b24],.fade-leave-to[data-v-a5134b24]{opacity:0}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-a5134b24","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/order/OrderInfo.vue
// module id = 100
// module chunks = 0